"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDom = require("react-dom");
const expoSensor_1 = require("../../lib/expoSensor");
class ExpoHandler extends React.Component {
    componentDidMount() {
        const el = ReactDom.findDOMNode(this);
        expoSensor_1.default.addHook({
            el,
            onExpo: this.props.onExpo,
        });
    }
    render() {
        return React.Children.only(this.props.children);
    }
}
exports.default = ExpoHandler;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSwrQkFBZ0M7QUFDaEMsc0NBQXVDO0FBQ3ZDLHFEQUE4QztBQUM5QyxNQUFxQixXQUFZLFNBQVEsS0FBSyxDQUFDLFNBRTdDO0lBRVMsaUJBQWlCO1FBQ3BCLE1BQU0sRUFBRSxHQUFHLFFBQVEsQ0FBQyxXQUFXLENBQUMsSUFBSSxDQUFDLENBQUM7UUFDdEMsb0JBQVUsQ0FBQyxPQUFPLENBQUM7WUFDZixFQUFFO1lBQ0YsTUFBTSxFQUFFLElBQUksQ0FBQyxLQUFLLENBQUMsTUFBTTtTQUM1QixDQUFDLENBQUM7SUFDUCxDQUFDO0lBRU0sTUFBTTtRQUNULE9BQU8sS0FBSyxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxRQUFRLENBQUMsQ0FBQztJQUNwRCxDQUFDO0NBQ0o7QUFmRCw4QkFlQyJ9